import { SchemeTypes } from '../../../../config';
import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  form_error_required: {
    [LanguagesEnum.English]: 'This is required',
    [LanguagesEnum.Greek]: 'Υποχρεωτικό πεδίο',
  },
  identification_details_header: {
    [LanguagesEnum.English]: 'Identification Details',
    [LanguagesEnum.Greek]: 'Στοιχεία ταυτοποίησης',
  },
  intermediary_help: {
    [LanguagesEnum.English]: 'If any',
    [LanguagesEnum.Greek]: 'Αν υπάρχει',
  },
  company_name_label: {
    [LanguagesEnum.English]: 'Company Name',
    [LanguagesEnum.Greek]: 'Όνομα Eταιρείας',
  },
  vat_number_label: {
    [LanguagesEnum.English]: 'VAT Number',
    [LanguagesEnum.Greek]: 'Όνομα Eταιρείας',
  },
  place_of_business_label: {
    [LanguagesEnum.English]: 'Place of business',
    [LanguagesEnum.Greek]: 'Χώρα επιχείρησης',
  },
  place_of_business_help: {
    [LanguagesEnum.English]:
      'Select the country where the NETP has his place of business.',
    [LanguagesEnum.Greek]:
      'Select the country where the NETP has his place of business.',
  },
  issuing_country_labels: {
    [LanguagesEnum.English]: 'Issuing Country',
    [LanguagesEnum.Greek]: 'Χώρα έκδοσης',
  },
  issuing_country_help: {
    [LanguagesEnum.English]:
      'Select the country which had issued the National Tax. Number.',
    [LanguagesEnum.Greek]:
      'Select the country which had issued the National Tax. Number.',
  },
  trading_name: {
    [LanguagesEnum.English]: 'Trading Name',
    [LanguagesEnum.Greek]: 'Εμπορική επωνυμία',
  },
  trading_name_help: {
    [LanguagesEnum.English]:
      'Please enter your company trading name, if they are different form the Company Name.',
    [LanguagesEnum.Greek]:
      'Προσθέστε την εμπορική σας επονυμία αν αυτή είναι διαφορετική από το Όνομα Eταιρείας',
  },
};

export const CanModify = {
  [SchemeTypes.EU]: (is_agent?: boolean): string[] => {
    return [
      'identificationDetails_companyName',
      'identificationDetails_trading_name',
      'identificationDetails_vatGroup',
    ];
  },
  [SchemeTypes.NON_EU]: (is_agent?: boolean): string[] => {
    return [
      'identificationDetails_companyName',
      'identificationDetails_placeOfBusiness',
      'identificationDetails_trading_name',
    ];
  },
  [SchemeTypes.IOSS]: (is_agent: boolean): string[] => {
    if (is_agent) {
      return [
        'identificationDetails_companyName',
        'identificationDetails_trading_name',
      ];
    } else {
      return [
        'identificationDetails_companyName',
        'identificationDetails_trading_name',
        'identificationDetails_placeOfBusiness',
      ];
    }
  },
};

export default CONFIGURATION;
